import { Customer_FuelingContracts } from 'data/endpoints';
import DataGrid from 'features/shared/components/dataGrid/DataGrid';
import { DataGridId } from 'features/shared/components/dataGrid/DataGridId';
import { loadDataFilterConfig } from 'features/shared/helpers/modules';
import React from 'react';
import FuelingContractSimplified from 'features/contracts/components/FuelingContractSimplified';
import { getQueryParams } from 'features/shared/helpers/queryParams';
import { CommodityDetail } from 'features/contracts/enums/commodityDetail';
import FuelingContractSimplifiedHeader from 'features/contracts/components/FuelingContractSimplifiedHeader';

const fuelingContractsDataFilterJson = loadDataFilterConfig("fuelingContractsDataFilter");

const FuelingContractsSection = () => {
  return (
    <DataGrid
      gridId={DataGridId.contractGrid}
      url={Customer_FuelingContracts}
      filterJson={fuelingContractsDataFilterJson}
      renderItem={(item) => <FuelingContractSimplified contract={item} />}
      renderHeader={() => <FuelingContractSimplifiedHeader />}
      // renderGridHeaderBtns={() => <InvoiceSimulationButton />}
      noFilterQueryParams={getQueryParams("CommodityDetail", CommodityDetail.eMobility)}
    />
  )
}

export default FuelingContractsSection;